module.exports = __webpack_public_path__ + "static/media/pm.6359f9ee.svg";